import { LucideIcon } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export interface CarbonScoreMetricProps {
  statValue: number | string;
  metricTitle: string;
  icon?: LucideIcon;
  isLoading?: boolean;
  subTitle?: string;
}

export const CarbonScoreMetric = ({ statValue, metricTitle, icon: Icon, isLoading = false, subTitle }: CarbonScoreMetricProps) => {
  return (
    <article className="min-w-48 rounded-lg border border-slate-300 bg-white p-6">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-4">
          <p className="font-body text-[14px] font-normal leading-6 text-gray-700">{metricTitle}</p>
          {Icon && (
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <Icon className="h-6 w-6 text-slate-400" />
            </div>
          )}
        </div>
        <div className="mt-2">
          {isLoading ? (
            <Skeleton className="h-8 w-16" />
          ) : (
            <h5 className="text-[24px] font-semibold leading-8 text-gray-900">{statValue}</h5>
          )}
        </div>
        {subTitle && <span className="font-body text-[12px] italic leading-5 text-gray-500">{subTitle}</span>}
      </div>
    </article>
  );
};
